import { ElasticSearchResponse, OtherFront, OtherFrontDocument } from '@shared/services/elastic-search/models';

export const otherFrontsSerializer = (otherFronts: ElasticSearchResponse<OtherFrontDocument>): OtherFront[] =>
  otherFronts.hits.hits.map((otherFront) => {
    const source = otherFront._source;

    return {
      costLevel: source.field_categorie_facade_prix?.[0] ?? 0,
      url: source.field_page_link?.[0] ?? '',
      image: source.field_visuel?.[0] ?? undefined!,
      name: source.name?.[0] ?? '',
    };
  });
